import { mergeLastPriceUpdate } from "../lastPriceUpdate";
import GetAdminPricingSnapshotV2 from "../../../api-layer/pricing-api/GetAdminPricingSnapshotV2";
import GetUserPricingSnapshotV2 from "../../../api-layer/pricing-api/GetUserPricingSnapshotV2";
import { useRequestStatusStore } from "../../requestStatusStore";
import { normalizeAdminSnapshot } from "../normalizeAdminSnapshot";
import { normalizeUserSnapshot } from "../normalizers/normalizeUserSnapshot";

export async function fetchSnapshotV2({ get, set, user }) {
    set({ loading: true });

    try {

        const isAdmin = user?.isAdmin;
        const response = isAdmin ? await GetAdminPricingSnapshotV2(user.id) : await GetUserPricingSnapshotV2(user.id);
        // Ignore a response belonging to a previous login or role.
        if (get().user?.id !== user?.id || get().user?.isAdmin !== user?.isAdmin) return;
        const categories = Array.isArray(response.data) ? response.data : response.data.categories;
        const normalized = isAdmin ? normalizeAdminSnapshot(categories) : normalizeUserSnapshot(categories);
        set(state => ({
            snapshot: categories,
            lastPriceUpdate: mergeLastPriceUpdate(state.lastPriceUpdate, response.data.lastPriceUpdate, isAdmin),
            quantitiesById: normalized.quantitiesById,
            categoryIds: normalized.categoryIds,
            categoriesById: normalized.categoriesById,

            loading: false,
        }));

        useRequestStatusStore.getState()
            .checkSnapshotPrices(
                normalized.quantitiesById
            );


    } catch (e) {
        set({
            loading: false,
        });
    }
}